import styled from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';

const listSummaryHeight = '50px';

export const ListSummary = styled.div`
  height: ${listSummaryHeight};
  z-index: 3;
  padding: ${layout.spacing.xSmall};
  padding-bottom: ${layout.spacing.small};
  border-top: 1px solid ${p => p.theme.lines.quaternary};
  background: ${p => p.theme.bg.primary};
  position: sticky;
  bottom: calc(-1 * ${layout.spacing.xSmall});
  width: 100%;

  ${media.mediumDown`
    width: 100%;
  `}
`;

export const ListSummaryPrice = styled.span`
  &,
  span {
    display: block;
    width: 100%;

    strong {
      float: right;
    }
  }
`;

export const ListWrapper = styled.div``;
